// frontend/src/pages/auth/ResendVerification.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';
import { Mail, CheckCircle } from 'react-feather';
import api from '../../services/api';
import { toast } from 'react-toastify';

const ResendVerification: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    
    setIsSubmitting(true);
    
    try {
      await api.post('/auth/resend-verification', { email });
      setSuccess(true);
      toast.success('Verification email sent! Please check your inbox.');
    } catch (error) {
      toast.error('Failed to send verification email. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Mail className="h-12 w-12 text-pink-500" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Resend Verification Email
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card>
          {success ? (
            <div className="px-4 py-5 sm:p-6 text-center">
              <div className="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
                <CheckCircle className="w-6 h-6 text-green-600" />
              </div>
              
              <h3 className="mt-3 text-lg font-medium text-gray-900">
                Verification Email Sent
              </h3>
              
              <p className="mt-2 text-sm text-gray-500">
                We've sent a verification email to <span className="font-medium">{email}</span>.
                Please check your inbox and click the verification link to activate your account.
              </p>
              
              <div className="mt-6">
                <Button onClick={() => navigate('/login')} fullWidth>
                  Back to Login
                </Button>
              </div>
            </div>
          ) : (
            <div className="px-4 py-5 sm:p-6">
              <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                  id="email"
                  label="Email Address"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                />
                
                <Button 
                  type="submit" 
                  fullWidth 
                  loading={isSubmitting}
                  disabled={isSubmitting || !email}
                >
                  Send Verification Email
                </Button>
                
                <div className="text-center">
                  <Button 
                    variant="outline" 
                    onClick={() => navigate('/login')}
                  >
                    Back to Login
                  </Button>
                </div>
              </form>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ResendVerification;